module.exports = __webpack_public_path__ + "static/media/graph-1.189d3127.svg";